export * from './esri4-map/index';
export * from './core/index';
export * from './widgets/index';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
